module.exports = __webpack_public_path__ + "media/images/devices/device-feature-drills-ad569e356f9166407839e8b8857585e4.png";